// import React, { useState, useEffect } from "react";
// import {
//   Steps,
//   Card,
//   Button,
//   Space,
//   Divider,
//   Row,
//   Col,
//   Spin,
//   Input,
//   message as antMessage,
// } from "antd";
// import { useNavigate } from "react-router-dom";
// import AddressManagement from "./myaccount/Addresses";
// import PaymentMethod from "../components/checkout/PaymentMethod";
// import OrderSummary from "../components/checkout/OrderSummary";
// import settingService from "../services/settingService";
// import orderService from "../services/orderService";
// import { toast } from "react-toastify";
// import "./CheckoutPage.css";

// const { Step } = Steps;

// const CheckoutPage = () => {
//   const navigate = useNavigate();

//   const [currentStep, setCurrentStep] = useState(0);
//   const [selectedAddress, setSelectedAddress] = useState(null);
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("online");
//   const [codEnabled, setCodEnabled] = useState(false);
//   const [deliveryFee, setDeliveryFee] = useState(0);
//   const [settingsLoading, setSettingsLoading] = useState(true);
//   const [cartItems, setCartItems] = useState([]);
//   const [discountCode, setDiscountCode] = useState("");
//   const [appliedDiscount, setAppliedDiscount] = useState(null);
//   const [discountLoading, setDiscountLoading] = useState(false);
//   const [orderLoading, setOrderLoading] = useState(false);

//   const subtotal = cartItems.reduce(
//     (sum, item) => sum + item.price * item.quantity,
//     0
//   );

//   const discountAmount = appliedDiscount?.discountAmount || 0;
//   const finalTotal = subtotal + deliveryFee - discountAmount;

//   useEffect(() => {
//     const savedCart = localStorage.getItem("cart");
//     if (savedCart) {
//       setCartItems(JSON.parse(savedCart));
//     }
//     fetchSettings();
//   }, []);

//   useEffect(() => {
//     if (subtotal > 0) {
//       calculateDeliveryFee();
//     }
//   }, [subtotal]);

//   const fetchSettings = async () => {
//     try {
//       setSettingsLoading(true);
//       const response = await settingService.getSettings();

//       if (response?.success) {
//         setCodEnabled(response.data.codEnabled);

//         if (!response.data.codEnabled && selectedPaymentMethod === "cod") {
//           setSelectedPaymentMethod("online");
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching settings:", error);
//       toast.error("Failed to load settings");
//       setCodEnabled(false);
//     } finally {
//       setSettingsLoading(false);
//     }
//   };

//   const calculateDeliveryFee = async () => {
//     try {
//       const response = await settingService.getSettings();

//       if (response?.success) {
//         const deliveryFees = response.data.deliveryFees || [];

//         const matchingFee = deliveryFees.find(
//           (fee) =>
//             fee.isActive &&
//             subtotal >= fee.minAmount &&
//             subtotal <= fee.maxAmount
//         );

//         setDeliveryFee(matchingFee ? matchingFee.fee : 0);
//       }
//     } catch (error) {
//       console.error("Error calculating delivery fee:", error);
//       setDeliveryFee(0);
//     }
//   };

//   const handleApplyDiscount = async () => {
//     if (!discountCode.trim()) {
//       toast.error("Please enter a discount code");
//       return;
//     }

//     try {
//       setDiscountLoading(true);
//       const response = await orderService.validateDiscount({
//         code: discountCode,
//         orderAmount: subtotal,
//       });

//       if (response?.success) {
//         setAppliedDiscount(response.data);
//         toast.success("Discount applied successfully!");
//       }
//     } catch (error) {
//       console.error("Error applying discount:", error);
//       toast.error(error?.response?.data?.message || "Invalid discount code");
//       setAppliedDiscount(null);
//     } finally {
//       setDiscountLoading(false);
//     }
//   };

//   const handleRemoveDiscount = () => {
//     setDiscountCode("");
//     setAppliedDiscount(null);
//     toast.info("Discount removed");
//   };

//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const handleRazorpayPayment = async (orderData) => {
//     try {
//       const scriptLoaded = await loadRazorpayScript();
//       if (!scriptLoaded) {
//         toast.error("Failed to load payment gateway");
//         return;
//       }

//       // Create Razorpay order
//       const razorpayOrderResponse = await orderService.createRazorpayOrder({
//         amount: finalTotal,
//         receipt: `order_${Date.now()}`,
//       });

//       if (!razorpayOrderResponse?.success) {
//         toast.error("Failed to initialize payment");
//         return;
//       }

//       const options = {
//         key: process.env.REACT_APP_RAZORPAY_KEY_ID,
//         amount: razorpayOrderResponse.data.amount,
//         currency: razorpayOrderResponse.data.currency,
//         name: "Your Store Name",
//         description: "Order Payment",
//         order_id: razorpayOrderResponse.data.id,
//         handler: async function (response) {
//           try {
//             // Verify payment
//             const verifyResponse = await orderService.verifyRazorpayPayment({
//               razorpay_order_id: response.razorpay_order_id,
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_signature: response.razorpay_signature,
//             });

//             if (verifyResponse?.success) {
//               // Create order with payment details
//               await createFinalOrder({
//                 ...orderData,
//                 razorpayOrderId: response.razorpay_order_id,
//                 razorpayPaymentId: response.razorpay_payment_id,
//               });
//             }
//           } catch (error) {
//             console.error("Payment verification failed:", error);
//             toast.error("Payment verification failed");
//           }
//         },
//         prefill: {
//           name: selectedAddress?.name || "",
//           contact: selectedAddress?.mobile || "",
//         },
//         theme: {
//           color: "#2c2c2c",
//         },
//       };

//       const razorpay = new window.Razorpay(options);
//       razorpay.open();
//     } catch (error) {
//       console.error("Razorpay error:", error);
//       toast.error("Payment failed. Please try again.");
//     }
//   };

//   const createFinalOrder = async (orderData) => {
//     try {
//       setOrderLoading(true);
//       const response = await orderService.createOrder(orderData);

//       if (response?.success) {
//         toast.success("Order placed successfully!");
//         localStorage.removeItem("cart");
//         navigate("/orders");
//       }
//     } catch (error) {
//       console.error("Error creating order:", error);
//       toast.error(error?.response?.data?.message || "Failed to place order");
//     } finally {
//       setOrderLoading(false);
//     }
//   };

//   const handlePlaceOrder = async () => {
//     try {
//       if (!selectedAddress) {
//         toast.error("Please select a delivery address");
//         return;
//       }

//       if (!selectedPaymentMethod) {
//         toast.error("Please select a payment method");
//         return;
//       }

//       const orderData = {
//         items: cartItems,
//         shippingAddress: selectedAddress._id,
//         paymentMethod: selectedPaymentMethod,
//         subtotal: subtotal,
//         deliveryFee: deliveryFee,
//         discountCode: appliedDiscount?.code || null,
//         totalAmount: finalTotal,
//       };

//       if (selectedPaymentMethod === "online") {
//         await handleRazorpayPayment(orderData);
//       } else {
//         await createFinalOrder(orderData);
//       }
//     } catch (error) {
//       console.error("Error placing order:", error);
//       toast.error("Failed to place order");
//     }
//   };

//   const handleAddressSelect = (address) => {
//     setSelectedAddress(address);
//   };

//   const handlePaymentMethodChange = (method) => {
//     setSelectedPaymentMethod(method);
//   };

//   const handleNext = () => {
//     if (currentStep === 0) {
//       if (!selectedAddress) {
//         toast.error("Please select a delivery address");
//         return;
//       }
//     }

//     if (currentStep === 1) {
//       if (!selectedPaymentMethod) {
//         toast.error("Please select a payment method");
//         return;
//       }
//     }

//     setCurrentStep(currentStep + 1);
//   };

//   const handlePrevious = () => {
//     setCurrentStep(currentStep - 1);
//   };

//   const steps = [
//     { title: "Address", content: "address" },
//     { title: "Payment", content: "payment" },
//     { title: "Review", content: "review" },
//   ];

//   const renderStepContent = () => {
//     switch (currentStep) {
//       case 0:
//         return (
//           <AddressManagement
//             onSelectAddress={handleAddressSelect}
//             selectionMode={true}
//           />
//         );

//       case 1:
//         return (
//           <div>
//             {settingsLoading ? (
//               <div style={{ textAlign: "center", padding: "40px" }}>
//                 <Spin size="large" tip="Loading payment methods..." />
//               </div>
//             ) : (
//               <>
//                 <h3 style={{ marginBottom: "20px" }}>Select Payment Method</h3>
//                 <PaymentMethod
//                   selectedMethod={selectedPaymentMethod}
//                   onMethodChange={handlePaymentMethodChange}
//                   codEnabled={codEnabled}
//                 />
//               </>
//             )}
//           </div>
//         );

//       case 2:
//         return (
//           <Row gutter={24}>
//             <Col xs={24} lg={16}>
//               <Card title="Review Your Order" style={{ marginBottom: "20px" }}>
//                 <Divider orientation="left">Delivery Address</Divider>
//                 {selectedAddress ? (
//                   <div className="review-address">
//                     <p>
//                       <strong>{selectedAddress.name}</strong>
//                     </p>
//                     <p>{selectedAddress.addressLine1}</p>
//                     {selectedAddress.addressLine2 && (
//                       <p>{selectedAddress.addressLine2}</p>
//                     )}
//                     {selectedAddress.landmark && (
//                       <p>Landmark: {selectedAddress.landmark}</p>
//                     )}
//                     <p>
//                       {selectedAddress.city}, {selectedAddress.state} -{" "}
//                       {selectedAddress.pincode}
//                     </p>
//                     <p>Mobile: {selectedAddress.mobile}</p>
//                   </div>
//                 ) : (
//                   <p>No address selected</p>
//                 )}

//                 <Divider orientation="left">Payment Method</Divider>
//                 <div className="review-payment">
//                   <p>
//                     <strong>
//                       {selectedPaymentMethod === "cod"
//                         ? "Cash on Delivery (COD)"
//                         : "Pay online"}
//                     </strong>
//                   </p>
//                   <p className="payment-description">
//                     {selectedPaymentMethod === "cod"
//                       ? "Pay when you receive your order"
//                       : "Secure payment via Razorpay"}
//                   </p>
//                 </div>

//                 <Divider orientation="left">Apply Discount</Divider>
//                 <div className="discount-section">
//                   {!appliedDiscount ? (
//                     <Space.Compact style={{ width: "100%" }}>
//                       <Input
//                         placeholder="Enter discount code"
//                         value={discountCode}
//                         onChange={(e) =>
//                           setDiscountCode(e.target.value.toUpperCase())
//                         }
//                         onPressEnter={handleApplyDiscount}
//                       />
//                       <Button
//                         type="primary"
//                         onClick={handleApplyDiscount}
//                         loading={discountLoading}
//                       >
//                         Apply
//                       </Button>
//                     </Space.Compact>
//                   ) : (
//                     <div className="applied-discount">
//                       <p>
//                         <strong>{appliedDiscount.code}</strong> applied! You
//                         saved ₹{appliedDiscount.discountAmount.toFixed(2)}
//                       </p>
//                       <Button type="link" danger onClick={handleRemoveDiscount}>
//                         Remove
//                       </Button>
//                     </div>
//                   )}
//                 </div>
//               </Card>
//             </Col>

//             <Col xs={24} lg={8}>
//               <OrderSummary
//                 items={cartItems}
//                 total={subtotal}
//                 deliveryFee={deliveryFee}
//                 discount={discountAmount}
//                 finalTotal={finalTotal}
//               />
//             </Col>
//           </Row>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="checkout-page">
//       <div className="checkout-container">
//         <h1>Checkout</h1>

//         <Steps current={currentStep} style={{ marginBottom: "30px" }}>
//           {steps.map((step) => (
//             <Step key={step.title} title={step.title} />
//           ))}
//         </Steps>

//         <div className="checkout-content">{renderStepContent()}</div>

//         <div className="checkout-actions">
//           <Space>
//             {currentStep > 0 && (
//               <Button size="large" onClick={handlePrevious}>
//                 Previous
//               </Button>
//             )}

//             {currentStep < steps.length - 1 && (
//               <Button
//                 type="primary"
//                 size="large"
//                 onClick={handleNext}
//                 disabled={currentStep === 1 && settingsLoading}
//               >
//                 Next
//               </Button>
//             )}

//             {currentStep === steps.length - 1 && (
//               <Button
//                 type="primary"
//                 size="large"
//                 onClick={handlePlaceOrder}
//                 loading={orderLoading}
//               >
//                 {selectedPaymentMethod === "online"
//                   ? `Pay ₹${finalTotal.toFixed(2)}`
//                   : "Place Order"}
//               </Button>
//             )}
//           </Space>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CheckoutPage;

// import React, { useState, useEffect } from "react";
// import {
//   Steps,
//   Card,
//   Button,
//   Space,
//   Divider,
//   Row,
//   Col,
//   Spin,
//   Input,
//   Modal,
// } from "antd";
// import { useNavigate } from "react-router-dom";
// import AddressManagement from "./myaccount/Addresses";
// import PaymentMethod from "../components/checkout/PaymentMethod";
// import OrderSummary from "../components/checkout/OrderSummary";
// import settingService from "../services/settingService";
// import orderService from "../services/orderService";
// import { toast } from "react-toastify";
// import useRazorpay from "../hooks/useRazorpay";
// import "./CheckoutPage.css";

// const { Step } = Steps;

// const CheckoutPage = () => {
//   const navigate = useNavigate();
//   const isRazorpayLoaded = useRazorpay();

//   const [currentStep, setCurrentStep] = useState(0);
//   const [selectedAddress, setSelectedAddress] = useState(null);
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("online");
//   const [codEnabled, setCodEnabled] = useState(false);
//   const [deliveryFee, setDeliveryFee] = useState(0);
//   const [settingsLoading, setSettingsLoading] = useState(true);
//   const [cartItems, setCartItems] = useState([]);
//   const [discountCode, setDiscountCode] = useState("");
//   const [appliedDiscount, setAppliedDiscount] = useState(null);
//   const [discountLoading, setDiscountLoading] = useState(false);
//   const [orderLoading, setOrderLoading] = useState(false);

//   const subtotal = cartItems.reduce(
//     (sum, item) => sum + item.price * item.quantity,
//     0
//   );

//   const discountAmount = appliedDiscount?.discountAmount || 0;
//   const finalTotal = subtotal + deliveryFee - discountAmount;

//   useEffect(() => {
//     const savedCart = localStorage.getItem("cart");
//     if (savedCart) {
//       setCartItems(JSON.parse(savedCart));
//     }
//     fetchSettings();
//   }, []);

//   useEffect(() => {
//     if (subtotal > 0) {
//       calculateDeliveryFee();
//     }
//   }, [subtotal]);

//   const fetchSettings = async () => {
//     try {
//       setSettingsLoading(true);
//       const response = await settingService.getSettings();

//       if (response?.success) {
//         setCodEnabled(response.data.codEnabled);

//         if (!response.data.codEnabled && selectedPaymentMethod === "cod") {
//           setSelectedPaymentMethod("online");
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching settings:", error);
//       toast.error("Failed to load settings");
//       setCodEnabled(false);
//     } finally {
//       setSettingsLoading(false);
//     }
//   };

//   const calculateDeliveryFee = async () => {
//     try {
//       const response = await settingService.getSettings();

//       if (response?.success) {
//         const deliveryFees = response.data.deliveryFees || [];

//         const matchingFee = deliveryFees.find(
//           (fee) =>
//             fee.isActive &&
//             subtotal >= fee.minAmount &&
//             subtotal <= fee.maxAmount
//         );

//         setDeliveryFee(matchingFee ? matchingFee.fee : 0);
//       }
//     } catch (error) {
//       console.error("Error calculating delivery fee:", error);
//       setDeliveryFee(0);
//     }
//   };

//   const handleApplyDiscount = async () => {
//     if (!discountCode.trim()) {
//       toast.error("Please enter a discount code");
//       return;
//     }

//     try {
//       setDiscountLoading(true);
//       const response = await orderService.validateDiscount({
//         code: discountCode,
//         orderAmount: subtotal,
//       });

//       if (response?.success) {
//         setAppliedDiscount(response.data);
//         toast.success("Discount applied successfully!");
//       }
//     } catch (error) {
//       console.error("Error applying discount:", error);
//       toast.error(error?.response?.data?.message || "Invalid discount code");
//       setAppliedDiscount(null);
//     } finally {
//       setDiscountLoading(false);
//     }
//   };

//   const handleRemoveDiscount = () => {
//     setDiscountCode("");
//     setAppliedDiscount(null);
//     toast.info("Discount removed");
//   };

//   const handleRazorpayPayment = async (orderData) => {
//     if (!isRazorpayLoaded) {
//       toast.error("Payment gateway is not ready. Please try again.");
//       return;
//     }

//     if (!window.Razorpay) {
//       toast.error("Payment gateway failed to load. Please refresh the page.");
//       return;
//     }

//     try {
//       setOrderLoading(true);

//       // Create Razorpay order
//       const razorpayOrderResponse = await orderService.createRazorpayOrder({
//         amount: finalTotal,
//         receipt: `order_${Date.now()}`,
//       });

//       if (!razorpayOrderResponse?.success) {
//         toast.error("Failed to initialize payment");
//         setOrderLoading(false);
//         return;
//       }

//       const options = {
//         key: process.env.REACT_APP_RAZORPAY_KEY_ID,
//         amount: razorpayOrderResponse.data.amount,
//         currency: razorpayOrderResponse.data.currency,
//         name: "Kitty N' Mice",
//         description: "Order Payment",
//         image: "/logo.png", // Add your logo path
//         order_id: razorpayOrderResponse.data.id,
//         handler: async function (response) {
//           try {
//             console.log("Payment successful:", response);

//             // Verify payment
//             const verifyResponse = await orderService.verifyRazorpayPayment({
//               razorpay_order_id: response.razorpay_order_id,
//               razorpay_payment_id: response.razorpay_payment_id,
//               razorpay_signature: response.razorpay_signature,
//             });

//             if (verifyResponse?.success) {
//               // Create order with payment details
//               await createFinalOrder({
//                 ...orderData,
//                 razorpayOrderId: response.razorpay_order_id,
//                 razorpayPaymentId: response.razorpay_payment_id,
//               });
//             } else {
//               toast.error("Payment verification failed");
//               setOrderLoading(false);
//             }
//           } catch (error) {
//             console.error("Payment verification failed:", error);
//             toast.error("Payment verification failed. Please contact support.");
//             setOrderLoading(false);
//           }
//         },
//         prefill: {
//           name: selectedAddress?.name || "",
//           contact: selectedAddress?.mobile || "",
//           email: "", // Add user email if available
//         },
//         notes: {
//           address: selectedAddress?.addressLine1 || "",
//           city: selectedAddress?.city || "",
//         },
//         theme: {
//           color: "#2c2c2c",
//         },
//         modal: {
//           ondismiss: function () {
//             console.log("Payment cancelled by user");
//             toast.info("Payment cancelled");
//             setOrderLoading(false);
//           },
//         },
//       };

//       const razorpay = new window.Razorpay(options);

//       razorpay.on("payment.failed", function (response) {
//         console.error("Payment failed:", response.error);
//         toast.error(`Payment failed: ${response.error.description}`);
//         setOrderLoading(false);
//       });

//       razorpay.open();
//     } catch (error) {
//       console.error("Razorpay error:", error);
//       toast.error("Payment failed. Please try again.");
//       setOrderLoading(false);
//     }
//   };

//   const createFinalOrder = async (orderData) => {
//     try {
//       const response = await orderService.createOrder(orderData);

//       if (response?.success) {
//         toast.success("Order placed successfully!");
//         localStorage.removeItem("cart");

//         // Show success modal with order details
//         Modal.success({
//           title: "Order Placed Successfully!",
//           content: (
//             <div>
//               <p>Your order has been placed successfully.</p>
//               <p>Order ID: {response.data.orderNumber || response.data._id}</p>
//               <p>Total Amount: ₹{finalTotal.toFixed(2)}</p>
//             </div>
//           ),
//           onOk() {
//             navigate("/my-account/orders");
//           },
//         });
//       }
//     } catch (error) {
//       console.error("Error creating order:", error);
//       toast.error(error?.response?.data?.message || "Failed to place order");
//     } finally {
//       setOrderLoading(false);
//     }
//   };

//   const handlePlaceOrder = async () => {
//     try {
//       if (!selectedAddress) {
//         toast.error("Please select a delivery address");
//         return;
//       }

//       if (!selectedPaymentMethod) {
//         toast.error("Please select a payment method");
//         return;
//       }

//       const orderData = {
//         items: cartItems,
//         shippingAddress: selectedAddress._id,
//         paymentMethod: selectedPaymentMethod,
//         subtotal: subtotal,
//         deliveryFee: deliveryFee,
//         discountCode: appliedDiscount?.code || null,
//         totalAmount: finalTotal,
//       };

//       if (selectedPaymentMethod === "online") {
//         await handleRazorpayPayment(orderData);
//       } else {
//         // COD Order
//         setOrderLoading(true);
//         await createFinalOrder(orderData);
//       }
//     } catch (error) {
//       console.error("Error placing order:", error);
//       toast.error("Failed to place order");
//       setOrderLoading(false);
//     }
//   };

//   const handleAddressSelect = (address) => {
//     setSelectedAddress(address);
//   };

//   const handlePaymentMethodChange = (method) => {
//     setSelectedPaymentMethod(method);
//   };

//   const handleNext = () => {
//     if (currentStep === 0) {
//       if (!selectedAddress) {
//         toast.error("Please select a delivery address");
//         return;
//       }
//     }

//     if (currentStep === 1) {
//       if (!selectedPaymentMethod) {
//         toast.error("Please select a payment method");
//         return;
//       }
//     }

//     setCurrentStep(currentStep + 1);
//   };

//   const handlePrevious = () => {
//     setCurrentStep(currentStep - 1);
//   };

//   const steps = [
//     { title: "Address", content: "address" },
//     { title: "Payment", content: "payment" },
//     { title: "Review", content: "review" },
//   ];

//   const renderStepContent = () => {
//     switch (currentStep) {
//       case 0:
//         return (
//           <AddressManagement
//             onSelectAddress={handleAddressSelect}
//             selectionMode={true}
//           />
//         );

//       case 1:
//         return (
//           <div>
//             {settingsLoading ? (
//               <div style={{ textAlign: "center", padding: "40px" }}>
//                 <Spin size="large" tip="Loading payment methods..." />
//               </div>
//             ) : (
//               <>
//                 <h3 style={{ marginBottom: "20px" }}>Select Payment Method</h3>
//                 <PaymentMethod
//                   selectedMethod={selectedPaymentMethod}
//                   onMethodChange={handlePaymentMethodChange}
//                   codEnabled={codEnabled}
//                 />
//                 {selectedPaymentMethod === "online" && !isRazorpayLoaded && (
//                   <div style={{ marginTop: "16px", color: "#ff4d4f" }}>
//                     Loading payment gateway...
//                   </div>
//                 )}
//               </>
//             )}
//           </div>
//         );

//       case 2:
//         return (
//           <Row gutter={24}>
//             <Col xs={24} lg={16}>
//               <Card title="Review Your Order" style={{ marginBottom: "20px" }}>
//                 <Divider orientation="left">Delivery Address</Divider>
//                 {selectedAddress ? (
//                   <div className="review-address">
//                     <p>
//                       <strong>{selectedAddress.name}</strong>
//                     </p>
//                     <p>{selectedAddress.addressLine1}</p>
//                     {selectedAddress.addressLine2 && (
//                       <p>{selectedAddress.addressLine2}</p>
//                     )}
//                     {selectedAddress.landmark && (
//                       <p>Landmark: {selectedAddress.landmark}</p>
//                     )}
//                     <p>
//                       {selectedAddress.city}, {selectedAddress.state} -{" "}
//                       {selectedAddress.pincode}
//                     </p>
//                     <p>Mobile: {selectedAddress.mobile}</p>
//                   </div>
//                 ) : (
//                   <p>No address selected</p>
//                 )}

//                 <Divider orientation="left">Payment Method</Divider>
//                 <div className="review-payment">
//                   <p>
//                     <strong>
//                       {selectedPaymentMethod === "cod"
//                         ? "Cash on Delivery (COD)"
//                         : "Pay online"}
//                     </strong>
//                   </p>
//                   <p className="payment-description">
//                     {selectedPaymentMethod === "cod"
//                       ? "Pay when you receive your order"
//                       : "Secure payment via Razorpay"}
//                   </p>
//                 </div>

//                 <Divider orientation="left">Apply Discount Code</Divider>
//                 <div className="discount-section">
//                   {!appliedDiscount ? (
//                     <Space.Compact style={{ width: "100%" }}>
//                       <Input
//                         placeholder="Enter discount code"
//                         value={discountCode}
//                         onChange={(e) =>
//                           setDiscountCode(e.target.value.toUpperCase())
//                         }
//                         onPressEnter={handleApplyDiscount}
//                         disabled={discountLoading}
//                       />
//                       <Button
//                         type="primary"
//                         onClick={handleApplyDiscount}
//                         loading={discountLoading}
//                       >
//                         Apply
//                       </Button>
//                     </Space.Compact>
//                   ) : (
//                     <div className="applied-discount">
//                       <div>
//                         <p className="discount-code">
//                           <strong>{appliedDiscount.code}</strong> applied!
//                         </p>
//                         <p className="discount-savings">
//                           You saved ₹{appliedDiscount.discountAmount.toFixed(2)}
//                         </p>
//                       </div>
//                       <Button type="link" danger onClick={handleRemoveDiscount}>
//                         Remove
//                       </Button>
//                     </div>
//                   )}
//                 </div>
//               </Card>
//             </Col>

//             <Col xs={24} lg={8}>
//               <OrderSummary
//                 items={cartItems}
//                 total={subtotal}
//                 deliveryFee={deliveryFee}
//                 discount={discountAmount}
//                 finalTotal={finalTotal}
//               />
//             </Col>
//           </Row>
//         );

//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="checkout-page">
//       <div className="checkout-container">
//         <h1>Checkout</h1>

//         <Steps current={currentStep} style={{ marginBottom: "30px" }}>
//           {steps.map((step) => (
//             <Step key={step.title} title={step.title} />
//           ))}
//         </Steps>

//         <div className="checkout-content">{renderStepContent()}</div>

//         <div className="checkout-actions">
//           <Space>
//             {currentStep > 0 && (
//               <Button
//                 size="large"
//                 onClick={handlePrevious}
//                 disabled={orderLoading}
//               >
//                 Previous
//               </Button>
//             )}

//             {currentStep < steps.length - 1 && (
//               <Button
//                 type="primary"
//                 size="large"
//                 onClick={handleNext}
//                 disabled={currentStep === 1 && settingsLoading}
//               >
//                 Next
//               </Button>
//             )}

//             {currentStep === steps.length - 1 && (
//               <Button
//                 type="primary"
//                 size="large"
//                 onClick={handlePlaceOrder}
//                 loading={orderLoading}
//                 disabled={
//                   (selectedPaymentMethod === "online" && !isRazorpayLoaded) ||
//                   orderLoading
//                 }
//               >
//                 {selectedPaymentMethod === "online"
//                   ? `Pay ₹${finalTotal.toFixed(2)}`
//                   : "Place Order"}
//               </Button>
//             )}
//           </Space>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CheckoutPage;

import React, { useState, useEffect } from "react";
import {
  Steps,
  Card,
  Button,
  Space,
  Divider,
  Row,
  Col,
  Spin,
  Input,
  Modal,
} from "antd";
import { useNavigate } from "react-router-dom";
import AddressManagement from "./myaccount/Addresses";
import PaymentMethod from "../components/checkout/PaymentMethod";
import OrderSummary from "../components/checkout/OrderSummary";
import settingService from "../services/settingService";
import orderService from "../services/orderService";
import { toast } from "react-toastify";
// import useRazorpay from "../hooks/useRazorpay";
import "./CheckoutPage.css";
import { useRazorpay, RazorpayOrderOptions } from "react-razorpay";
const CheckoutPage = () => {
  const navigate = useNavigate();
  // const isRazorpayLoaded = useRazorpay();
  const { error, isLoading, Razorpay } = useRazorpay();

  const [currentStep, setCurrentStep] = useState(0);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("online");
  const [codEnabled, setCodEnabled] = useState(false);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [settingsLoading, setSettingsLoading] = useState(true);
  const [cartItems, setCartItems] = useState([]);
  const [discountCode, setDiscountCode] = useState("");
  const [appliedDiscount, setAppliedDiscount] = useState(null);
  const [discountLoading, setDiscountLoading] = useState(false);
  const [orderLoading, setOrderLoading] = useState(false);

  const subtotal = cartItems.reduce(
    (sum, item) => sum + (item.offerPrice || item.price) * item.quantity,
    0
  );

  const discountAmount = appliedDiscount?.discountAmount || 0;
  const finalTotal = subtotal + deliveryFee - discountAmount;

  useEffect(() => {
    const savedCart = localStorage.getItem("cart");
    if (savedCart) {
      setCartItems(JSON.parse(savedCart));
    }
    fetchSettings();
  }, []);

  useEffect(() => {
    if (subtotal > 0) {
      calculateDeliveryFee();
    }
  }, [subtotal]);

  const fetchSettings = async () => {
    try {
      setSettingsLoading(true);
      const response = await settingService.getSettings();

      if (response?.success) {
        setCodEnabled(response.data.codEnabled);

        if (!response.data.codEnabled && selectedPaymentMethod === "cod") {
          setSelectedPaymentMethod("online");
        }
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
      toast.error("Failed to load settings");
      setCodEnabled(false);
    } finally {
      setSettingsLoading(false);
    }
  };

  const calculateDeliveryFee = async () => {
    try {
      const response = await settingService.getSettings();

      if (response?.success) {
        const deliveryFees = response.data.deliveryFees || [];

        const matchingFee = deliveryFees.find(
          (fee) =>
            fee.isActive &&
            subtotal >= fee.minAmount &&
            subtotal <= fee.maxAmount
        );

        setDeliveryFee(matchingFee ? matchingFee.fee : 0);
      }
    } catch (error) {
      console.error("Error calculating delivery fee:", error);
      setDeliveryFee(0);
    }
  };

  const handleApplyDiscount = async () => {
    if (!discountCode.trim()) {
      toast.error("Please enter a discount code");
      return;
    }

    try {
      setDiscountLoading(true);
      const response = await orderService.validateDiscount({
        code: discountCode,
        orderAmount: subtotal,
      });

      if (response?.success) {
        setAppliedDiscount(response.data);
        toast.success("Discount applied successfully!");
      }
    } catch (error) {
      console.error("Error applying discount:", error);
      toast.error(error?.response?.data?.message || "Invalid discount code");
      setAppliedDiscount(null);
    } finally {
      setDiscountLoading(false);
    }
  };

  const handleRemoveDiscount = () => {
    setDiscountCode("");
    setAppliedDiscount(null);
    toast.info("Discount removed");
  };

  const handleRazorpayPayment = async (orderData) => {
    console.log("hit handle");
    // if (!isRazorpayLoaded) {
    //   toast.error("Payment gateway is not ready. Please try again.");
    //   return;
    // }

    // if (!window.Razorpay) {
    //   toast.error("Payment gateway failed to load. Please refresh the page.");
    //   return;
    // }

    try {
      setOrderLoading(true);

      // Create Razorpay order
      const razorpayOrderResponse = await orderService.createRazorpayOrder({
        amount: finalTotal,
        receipt: `order_${Date.now()}`,
      });
      console.log(
        process.env.REACT_APP_RAZORPAY_KEY_ID,
        razorpayOrderResponse,
        "process.env.REACT_APP_RAZORPAY_KEY_ID"
      );
      if (razorpayOrderResponse?.status != "created") {
        toast.error("Failed to initialize payment");
        setOrderLoading(false);
        return;
      }

      const optionss = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: razorpayOrderResponse.amount,
        currency: razorpayOrderResponse.currency,
        name: "Kitty N' Mice",
        description: "Order Payment",
        image: "/logo.png",
        order_id: razorpayOrderResponse.id,
        handler: async function (response) {
          try {
            console.log("Payment successful:", response);

            const verifyResponse = await orderService.verifyRazorpayPayment({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            });
            console.log(verifyResponse, "verifyResponse");
            if (verifyResponse?.success) {
              await createFinalOrder({
                ...orderData,
                razorpayOrderId: response.razorpay_order_id,
                razorpayPaymentId: response.razorpay_payment_id,
              });
            } else {
              toast.error("Payment verification failed");
              setOrderLoading(false);
            }
          } catch (error) {
            console.error("Payment verification failed:", error);
            toast.error("Payment verification failed. Please contact support.");
            setOrderLoading(false);
          }
        },
        prefill: {
          name: selectedAddress?.name || "",
          contact: selectedAddress?.mobile || "",
          email: "",
        },
        notes: {
          address: selectedAddress?.addressLine1 || "",
          city: selectedAddress?.city || "",
        },
        theme: {
          color: "#2c2c2c",
        },
        modal: {
          ondismiss: function () {
            console.log("Payment cancelled by user");
            toast.info("Payment cancelled");
            setOrderLoading(false);
          },
        },
        config: {
          display: {
            blocks: {
              banks: {
                name: "Pay via UPI",
                instruments: [
                  {
                    method: "upi",
                  },
                ],
              },
              card: {
                name: "Debit/Credit Card",
                instruments: [
                  {
                    method: "card",
                  },
                ],
              },
            },
            sequence: ["block.banks", "block.card"],
            preferences: {
              show_default_blocks: false,
            },
          },
        },
      };
      // console.log(selectedAddress, razorpayOrderResponse, "test resss");
      // const options = {
      //   key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      //   amount: razorpayOrderResponse.amount, // Amount in paise
      //   currency: "INR",
      //   name: "Kitty N Mice",
      //   description: "Test Transaction",
      //   order_id: razorpayOrderResponse.id, // Generate order_id on server
      //   handler: (response) => {
      //     console.log(response);
      //     alert("Payment Successful!");
      //   },
      //   prefill: {
      //     name: selectedAddress?.name,
      //     email: selectedAddress?.email||"",
      //     contact:selectedAddress?.mobile,
      //   },
      //   theme: {
      //     color: "#F37254",
      //   },
      // };
      const razorpayInstance = new Razorpay(optionss);
      razorpayInstance.open();

      // razorpay.on("payment.failed", function (response) {
      //   console.error("Payment failed:", response.error);
      //   toast.error(`Payment failed: ${response.error.description}`);
      //   setOrderLoading(false);
      // });

      // razorpay.open();
    } catch (error) {
      console.error("Razorpay error:", error);
      toast.error("Payment failed. Please try again.");
      setOrderLoading(false);
    }
  };

  const createFinalOrder = async (orderData) => {
    try {
      const response = await orderService.createOrder(orderData);

      if (response?.success) {
        toast.success("Order placed successfully!");
        localStorage.removeItem("cart");

        Modal.success({
          title: "Order Placed Successfully!",
          content: (
            <div>
              <p>Your order has been placed successfully.</p>
              <p>Order ID: {response.data.orderNumber || response.data._id}</p>
              <p>Total Amount: ₹{finalTotal.toFixed(2)}</p>
            </div>
          ),
          onOk() {
            navigate("/myaccount");
          },
        });
      }
    } catch (error) {
      console.error("Error creating order:", error);
      toast.error(error?.response?.data?.message || "Failed to place order");
    } finally {
      setOrderLoading(false);
    }
  };

  const handlePlaceOrder = async () => {
    try {
      if (!selectedAddress) {
        toast.error("Please select a delivery address");
        return;
      }

      if (!selectedPaymentMethod) {
        toast.error("Please select a payment method");
        return;
      }

      const orderData = {
        items: cartItems,
        shippingAddress: selectedAddress._id,
        paymentMethod: selectedPaymentMethod,
        subtotal: subtotal,
        deliveryFee: deliveryFee,
        discountCode: appliedDiscount?.code || null,
        totalAmount: finalTotal,
      };

      if (selectedPaymentMethod === "online") {
        await handleRazorpayPayment(orderData);
      } else {
        setOrderLoading(true);
        await createFinalOrder(orderData);
      }
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("Failed to place order");
      setOrderLoading(false);
    }
  };

  const handleAddressSelect = (address) => {
    setSelectedAddress(address);
  };

  const handlePaymentMethodChange = (method) => {
    setSelectedPaymentMethod(method);
  };

  const handleNext = () => {
    if (currentStep === 0) {
      if (!selectedAddress) {
        toast.error("Please select a delivery address");
        return;
      }
    }

    if (currentStep === 1) {
      if (!selectedPaymentMethod) {
        toast.error("Please select a payment method");
        return;
      }
    }

    setCurrentStep(currentStep + 1);
  };

  const handlePrevious = () => {
    setCurrentStep(currentStep - 1);
  };

  const steps = [
    { title: "Address", description: "Delivery Address" },
    { title: "Payment", description: "Payment Method" },
    { title: "Review", description: "Review & Place Order" },
  ];

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <AddressManagement
            onSelectAddress={handleAddressSelect}
            selectionMode={true}
          />
        );

      case 1:
        return (
          <div>
            {settingsLoading ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <Spin size="large" tip="Loading payment methods..." />
              </div>
            ) : (
              <>
                <h3 style={{ marginBottom: "20px" }}>Select Payment Method</h3>
                <PaymentMethod
                  selectedMethod={selectedPaymentMethod}
                  onMethodChange={handlePaymentMethodChange}
                  codEnabled={codEnabled}
                />
                {selectedPaymentMethod === "online" && !isLoading && (
                  <div style={{ marginTop: "16px", color: "#ff4d4f" }}>
                    Loading payment gateway...
                  </div>
                )}
              </>
            )}
          </div>
        );

      case 2:
        return (
          <Row gutter={24}>
            <Col xs={24} lg={16}>
              <Card title="Review Your Order" style={{ marginBottom: "20px" }}>
                <Divider orientation="left">Delivery Address</Divider>
                {selectedAddress ? (
                  <div className="review-address">
                    <p>
                      <strong>{selectedAddress.name}</strong>
                    </p>
                    <p>{selectedAddress.addressLine1}</p>
                    {selectedAddress.addressLine2 && (
                      <p>{selectedAddress.addressLine2}</p>
                    )}
                    {selectedAddress.landmark && (
                      <p>Landmark: {selectedAddress.landmark}</p>
                    )}
                    <p>
                      {selectedAddress.city}, {selectedAddress.state} -{" "}
                      {selectedAddress.pincode}
                    </p>
                    <p>Mobile: {selectedAddress.mobile}</p>
                  </div>
                ) : (
                  <p>No address selected</p>
                )}

                <Divider orientation="left">Payment Method</Divider>
                <div className="review-payment">
                  <p>
                    <strong>
                      {selectedPaymentMethod === "cod"
                        ? "Cash on Delivery (COD)"
                        : "Pay online"}
                    </strong>
                  </p>
                  <p className="payment-description">
                    {selectedPaymentMethod === "cod"
                      ? "Pay when you receive your order"
                      : "Secure payment via Razorpay"}
                  </p>
                </div>

                <Divider orientation="left">Apply Discount Code</Divider>
                <div className="discount-section">
                  {!appliedDiscount ? (
                    <Space.Compact style={{ width: "100%" }}>
                      <Input
                        placeholder="Enter discount code"
                        value={discountCode}
                        onChange={(e) =>
                          setDiscountCode(e.target.value.toUpperCase())
                        }
                        onPressEnter={handleApplyDiscount}
                        disabled={discountLoading}
                      />
                      <Button
                        type="primary"
                        onClick={handleApplyDiscount}
                        loading={discountLoading}
                      >
                        Apply
                      </Button>
                    </Space.Compact>
                  ) : (
                    <div className="applied-discount">
                      <div>
                        <p className="discount-code">
                          <strong>{appliedDiscount.code}</strong> applied!
                        </p>
                        <p className="discount-savings">
                          You saved ₹{appliedDiscount.discountAmount.toFixed(2)}
                        </p>
                      </div>
                      <Button type="link" danger onClick={handleRemoveDiscount}>
                        Remove
                      </Button>
                    </div>
                  )}
                </div>
              </Card>
            </Col>

            <Col xs={24} lg={8}>
              <OrderSummary
                items={cartItems}
                total={subtotal}
                deliveryFee={deliveryFee}
                discount={discountAmount}
                finalTotal={finalTotal}
              />
            </Col>
          </Row>
        );

      default:
        return null;
    }
  };

  return (
    <div className="checkout-page">
      <div className="checkout-container">
        <h1>Checkout</h1>

        <Steps current={currentStep} style={{ marginBottom: "30px" }}>
          <Steps
            current={currentStep}
            style={{ marginBottom: "30px" }}
            items={steps}
          />
        </Steps>

        <div className="checkout-content">{renderStepContent()}</div>

        <div className="checkout-actions">
          <Space>
            {currentStep > 0 && (
              <Button
                size="large"
                onClick={handlePrevious}
                disabled={orderLoading}
              >
                Previous
              </Button>
            )}

            {currentStep < steps.length - 1 && (
              <Button
                type="primary"
                size="large"
                onClick={handleNext}
                disabled={currentStep === 1 && settingsLoading}
              >
                Next
              </Button>
            )}

            {currentStep === steps.length - 1 && (
              <Button
                type="primary"
                size="large"
                onClick={handlePlaceOrder}
                loading={orderLoading}
                disabled={
                  (selectedPaymentMethod === "online" && !isLoading) ||
                  orderLoading
                }
              >
                {selectedPaymentMethod === "online"
                  ? `Pay ₹${finalTotal.toFixed(2)}`
                  : "Place Order"}
              </Button>
            )}
          </Space>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;
